import BaseAPI from "@/api/BaseAPI";

export class FormOffersAPI extends BaseAPI {
    constructor() {
        super('/form2');
    }

    /**
     * @param {Number} id orgID
     * */
    read(id) {
        return this.http.get('/get', {data: {orgId: id}})
    }

    noAccreditationsCheck(id) {
        return this.http.get('/no_accreditations', {data: {orgId: id}})
    }

    create(data) {
        return this.http.post('/set', {data})
    }

    update(data) {
        return this.http.post('/set', {data})
    }

    delete(identifier) {
        return this.http.delete('/delete', {data: {rowId: identifier}})
    }

    /**
     * @param {Number} id kcpGroupId
     * */
    getBlockInfoForKcpGroup(id) {
        return this.http.get('/block/get', {data: {kcpGroupId: id}})
    }

    /**
     * @param {Number} id kcpGroupId
     * @param {Number} orgId orgId
     * */
    getMaxMinValuesInfoForKcpGroup(id, orgId) {
        return this.http.get('/restriction/get', {data: {kcpGroupId: id, orgId: orgId}})
    }
}

export default new FormOffersAPI()